import axios from "axios";
import { BASE_URL } from "../config";

const getAuthHeaders = () => {
  const token =
    localStorage.getItem("authentication/token") ||
    localStorage.getItem("auth_token") ||
    localStorage.getItem("token") ||
    "";

  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const uploadCptBatch = (formData) =>
  axios.post(`${BASE_URL}/cpt/batch-upload/upload`, formData, {
    headers: {
      ...getAuthHeaders(),
      "Content-Type": "multipart/form-data",
    },
  });

export const getCptBatchUploadHistory = (params) =>
  axios.get(`${BASE_URL}/cpt/batch-upload/uploads`, {
    params,
    headers: getAuthHeaders(),
  });

export const getCptBatchProcessedRows = (uploadId, params) =>
  axios.get(`${BASE_URL}/cpt/batch-upload/processed/${uploadId}`, {
    params,
    headers: getAuthHeaders(),
  });

export const exportCptBatchProcessedRows = (uploadId, params) =>
  axios.post(
    `${BASE_URL}/cpt/batch-upload/processed-export/${uploadId}`,
    {},
    {
      params,
      headers: getAuthHeaders(),
      responseType: "blob",
    }
  );

export const refreshCptBatchUploadSignedUrl = (uploadId) =>
  axios.post(
    `${BASE_URL}/cpt/batch-upload/refresh-url`,
    { upload_id: uploadId },
    { headers: getAuthHeaders() }
  );
